import * as React from "react"
import { cn } from "../../lib/utils"

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      className={cn(
        "flex h-10 w-full bg-surface-container-lowest px-4 py-3 text-sm text-on-surface transition-all outline-none ring-1 ring-outline-variant/20 rounded-lg placeholder:text-on-surface-variant/50 focus:ring-2 focus:ring-primary disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      {...props}
    />
  )
}

export { Input }
